/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { AddressCity } from '../models/address-city';
import { AddressStreet } from '../models/address-street';
import { findCityAddress } from '../fn/post-address/find-city-address';
import { FindCityAddress$Params } from '../fn/post-address/find-city-address';
import { findStreetAddress } from '../fn/post-address/find-street-address';
import { FindStreetAddress$Params } from '../fn/post-address/find-street-address';
import { getCountyAbbreviations } from '../fn/post-address/get-county-abbreviations';
import { GetCountyAbbreviations$Params } from '../fn/post-address/get-county-abbreviations';

@Injectable({ providedIn: 'root' })
export class PostAddressService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `findStreetAddress()` */
  static readonly FindStreetAddressPath = '/api/post_address/street/{classification}';

  /**
   * To fetch for street address related data
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findStreetAddress()` instead.
   *
   * This method doesn't expect any request body.
   */
  findStreetAddress$Response(params: FindStreetAddress$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AddressStreet>>> {
    return findStreetAddress(this.http, this.rootUrl, params, context);
  }

  /**
   * To fetch for street address related data
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findStreetAddress$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findStreetAddress(params: FindStreetAddress$Params, context?: HttpContext): Observable<Array<AddressStreet>> {
    return this.findStreetAddress$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AddressStreet>>): Array<AddressStreet> => r.body)
    );
  }

  /** Path part for operation `getCountyAbbreviations()` */
  static readonly GetCountyAbbreviationsPath = '/api/post_address/county';

  /**
   * To fetch all the county abbreviations
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCountyAbbreviations()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCountyAbbreviations$Response(params?: GetCountyAbbreviations$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<string>>> {
    return getCountyAbbreviations(this.http, this.rootUrl, params, context);
  }

  /**
   * To fetch all the county abbreviations
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCountyAbbreviations$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCountyAbbreviations(params?: GetCountyAbbreviations$Params, context?: HttpContext): Observable<Array<string>> {
    return this.getCountyAbbreviations$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<string>>): Array<string> => r.body)
    );
  }

  /** Path part for operation `findCityAddress()` */
  static readonly FindCityAddressPath = '/api/post_address/city';

  /**
   * To fetch for city address related data
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findCityAddress()` instead.
   *
   * This method doesn't expect any request body.
   */
  findCityAddress$Response(params?: FindCityAddress$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AddressCity>>> {
    return findCityAddress(this.http, this.rootUrl, params, context);
  }

  /**
   * To fetch for city address related data
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findCityAddress$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findCityAddress(params?: FindCityAddress$Params, context?: HttpContext): Observable<Array<AddressCity>> {
    return this.findCityAddress$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<AddressCity>>): Array<AddressCity> => r.body)
    );
  }

}
